var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import BillingPortalLayout from "../BillingPortalLayout";
import PlanSlide from "./PlanSlide";
export default function Index(_a) {
    var currentPlan = _a.currentPlan, hasDefaultPaymentMethod = _a.hasDefaultPaymentMethod, paymentMethods = _a.paymentMethods, plans = _a.plans, recurring = _a.recurring, cancelled = _a.cancelled, onGracePeriod = _a.onGracePeriod, endingDate = _a.endingDate;
    return _jsx(BillingPortalLayout, { children: _jsx("div", __assign({ className: "w-full sm:px-6 lg:px-8" }, { children: _jsx("div", __assign({ className: "space-y-6" }, { children: _jsx("div", __assign({ className: "grid grid-flow-row grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" }, { children: plans.map(function (plan, idx) {
                        return _jsx("div", __assign({ className: "w-full flex" }, { children: _jsx(PlanSlide, { plan: plan, active: currentPlan && plan.id === currentPlan.id, currentPlan: currentPlan, features: plan.features, recurring: recurring, cancelled: cancelled, onGracePeriod: onGracePeriod, endingDate: endingDate, 
                                // disable={idx === 0}
                                disable: false }) }), "plan-".concat(plan.id));
                    }) })) })) })) });
}
